import { createStyles } from '@material-ui/core';

export default () => createStyles({
  formControl: {
    width: '100%',
    backgroundColor: 'rgba(219, 92, 14, 0.08)',
    padding: '12px 20px',
    marginBottom: '44px',
    border: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '1.5',
    color: '#040620',

    '& label > span': {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '1.5',
      color: '#040620',
    },

    '& p': {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '1.57',
      color: '#040620',
      marginLeft: '32px',
    },
  },
  disabled: {
    filter: 'grayscale(1)',
    opacity: '0.5',
    pointerEvents: 'none',
  },
  dayBox: {
    width: '150px',
  },
  day: {
    fontWeight: 700,
    fontSize: '20px',
  },
  switchBox: {
    width: '150px',
  },
  staffWindow: {
    fontWeight: 700,
    padding: '10px 0',
  },
  select: {
    minWidth: '120px',
  },
  interval: {
    textAlign: 'center',
    margin: '10px 0',
    fontWeight: 700,
    color: '#8E8B99',
  },
  divider: {
    width: '100%',
    margin: '40px 0',
  },
  lockBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '140px',
  },
  lockTitle: {
    fontWeight: 600,
    color: '#DB5C0E',
    fontSize: '20px',
  },
  beta: {
    color: '#fb5700',
    fontSize: '10px',
    fontWeight: 'bold',
    position: 'absolute',
    marginLeft: '3px',
  },
  expiresOnWindow: {
    fontWeight: 700,
    padding: '10px 0',
  },
  expiresOnBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  expiresField: {
    width: 260,
    maxWidth: 260,
  },
  expiresHelper: {
    maxWidth: 260,
    whiteSpace: 'normal',
    lineHeight: 1.3,
    marginLeft: 0,
  },
});
